import { makeLogger } from '../logger/logger';

const { debug } = makeLogger({
  pathToCurrentFile: 'utils/memoize.ts',
  loggersList: ['debug', 'err']
});

//weakmap is weird, commenting it out untill we have time to investigate
//const _storage = new WeakMap<any, Map<string, unknown>>();


//this imitates weakmap,
// but doesn't clear data when reference to key is dropped
const _data = {};
const _storage = {
  set(key, value){
      _data[key] = value;
  },
  get(key){
      return _data[key];
  },
  has(key){
      return _data.hasOwnProperty(key);
  },
  delete(key){
      delete _data[key];
  },
  _data,
};

const calculateCacheKey = (args) =>{
    return JSON.stringify(args);
    // return {
    //     data: args
    // };
};

//keeping comments as they help to debug cache misbehavior

export const withStore = async <T> (args): Promise<T>=>{
    const {
      cbkArgs,
      cbk,
      weakMap = _storage,
    } = args;

    const key = calculateCacheKey(cbkArgs);


    debug('checking if key is in cache', key, weakMap);

    // debugger;

    if(weakMap.has(key)) {
      const v = weakMap.get(key);

      debug('has key in cache',key,v);

      return v;
    }

    debug('fetching live data');

    const r = await cbk(cbkArgs);

    weakMap.set(key, r);

    debug('stored data in cache', key, r, weakMap);

    return r;
};

withStore.clear = (callArgs)=>{
    const {
      args,
      weakMap = _storage,
    } = callArgs;
    weakMap.delete(calculateCacheKey(args));
};
